import styles from "./OpenHausArchitecture.module.css";
import type { ProjectArchitecture } from "../content/types";

type OpenHausArchitectureProps = {
  architecture: ProjectArchitecture;
  decorative?: boolean;
  className?: string;
};

export function OpenHausArchitecture({
  architecture,
  decorative,
  className,
}: OpenHausArchitectureProps) {
  return (
    <figure
      className={`${styles.figure} ${className ?? ""}`}
      aria-hidden={decorative ? true : undefined}
    >
      {decorative ? null : (
        <figcaption className={styles.caption}>{architecture.caption}</figcaption>
      )}
      <ol className={styles.layers}>
        {architecture.layers.map((layer) => (
          <li key={layer.id} className={styles.layer}>
            <p className={styles.layerLabel}>{layer.label}</p>
            <ul className={styles.items}>
              {layer.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </li>
        ))}
      </ol>
      {decorative
        ? null
        : architecture.notes?.map((note) => (
            <p key={note.title} className={styles.note}>
              <strong>{note.title}.</strong> {note.body}
            </p>
          ))}
    </figure>
  );
}
